"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getLiveTransmission;
const client_1 = __importDefault(require("../../client/client"));
function getLiveTransmission(config) {
    return client_1.default.get(config['API_URL'], '/live/assets');
}
